// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__vuCgv","title":"style_title__oBdxh","label":"style_label__3m5wm"};